<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div className="animated">
            <div class="mt-2">
              <h1 class="text-uppecase font-weight-bold">CREAR PROCESO</h1>
              <b-card>
                <b-form @submit.prevent="onSubmit" v-show="show">
                  <b-row>
                    <b-col sm="12" md="12" lg="6">
                      <b-form-group label="Exportadora">
                        <b-form-select
                          id="client"
                          :state="$v.form.client_customer.$dirty ? !$v.form.client_customer.$error : null"
                          v-model="$v.form.client_customer.$model"
                          :options="customers"
                        />
                        <b-form-invalid-feedback id="input-1-live-feedback">
                          Este campo es requerido.
                        </b-form-invalid-feedback>
                      </b-form-group>

                      <b-form-group label="Empresa">
                        <b-form-select
                          id="company"
                          :state="$v.form.company.$dirty ? !$v.form.company.$error : null"
                          v-model="$v.form.company.$model"
                          :options="companies"
                        />
                      </b-form-group>

                      <b-form-group label="Huerto">
                        <b-form-select
                          id="origin"
                          :state="$v.form.origin.$dirty ? !$v.form.origin.$error : null"
                          v-model="$v.form.origin.$model"
                          :options="origins"
                        />
                      </b-form-group>
                      <b-form-group label="Producto*">
                        <b-form-select
                          id="product"
                          :state="$v.form.product.$dirty ? !$v.form.product.$error : null"
                          v-model="$v.form.product.$model"
                          :options="products"
                        />
                        <b-form-invalid-feedback id="input-1-live-feedback">
                          Este campo es requerido.
                        </b-form-invalid-feedback>
                      </b-form-group>

                      <b-form-group label="Variedad">
                        <b-form-select
                          id="variety"
                          :state="$v.form.variety.$dirty ? !$v.form.variety.$error : null"
                          v-model="$v.form.variety.$model"
                          :options="varieties"
                        />
                      </b-form-group>

                      <b-form-group label="Condición">
                        <b-form-select
                          id="condition"
                          :state="$v.form.condition.$dirty ? !$v.form.condition.$error : null"
                          v-model="$v.form.condition.$model"
                          :options="conditions"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col sm="12" md="12" lg="6">
                      <b-form-group label="Planta">
                        <b-form-select
                          id="plant"
                          :state="$v.form.plant.$dirty ? !$v.form.plant.$error : null"
                          v-model="$v.form.plant.$model"
                          :options="plants"
                        />
                      </b-form-group>

                      <b-form-group label="Sala/Línea">
                        <b-form-select
                          id="process_room"
                          :state="$v.form.process_room.$dirty ? !$v.form.process_room.$error : null"
                          v-model="$v.form.process_room.$model"
                          :options="process_rooms"
                        />
                      </b-form-group>
                      <b-form-group label="Turno">
                        <b-form-select
                          id="shift"
                          :state="$v.form.shift.$dirty ? !$v.form.shift.$error : null"
                          v-model="$v.form.shift.$model"
                          :options="shifts"
                        />
                      </b-form-group>

                      <b-form-group label="Supervisor">
                        <b-form-select
                          id="supervisor"
                          :state="$v.form.shift_supervisor.$dirty ? !$v.form.shift_supervisor.$error : null"
                          v-model="$v.form.shift_supervisor.$model"
                          :options="supervisors"
                        />
                      </b-form-group>

                      <b-form-group>
                        <label for="shift_workers">Personal</label>
                        <b-form-input
                          type="number"
                          :state="$v.form.shift_workers.$dirty ? !$v.form.shift_workers.$error : null"
                          v-model="$v.form.shift_workers.$model"
                          id="shift_workers"
                          placeholder="Número de personas trabajando en el turno"
                        ></b-form-input>
                        <b-form-invalid-feedback id="shift_workers">
                          Este campo admite sólo números enteros.
                        </b-form-invalid-feedback>
                      </b-form-group>

                      <b-form-group v-if="userHasScope('edit-process-start-time')">
                        <label for="start_time">Hora de inicio</label>
                        <datetime
                          type="datetime"
                          :state="$v.form.start_time.$dirty ? !$v.form.start_time.$error : null"
                          v-model="$v.form.start_time.$model"
                          :minute-step="10"
                          auto
                          input-class="form-control"
                          class="theme-orange"
                        >
                        </datetime>
                      </b-form-group>

                      <b-form-group>
                        <label for="note">Notas:</label>
                        <b-form-textarea
                          id="textarea"
                          v-model="form.note"
                          placeholder="Escriba sus notas..."
                          rows="3"
                          max-rows="6"
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-button type="submit" :disabled="loading" variant="primary" class="float-right">Guardar</b-button>
                </b-form>
              </b-card>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { required, numeric, minLength, between, requiredIf } from "vuelidate/lib/validators";
import _ from "lodash";
import userHasScope from "../../utils/userHasScope";

export default {
  name: "ProcessMain",
  created() {
    this.getProducts();
    this.getCustomers();
    this.getPlantsInfo();
    if (this.$route.params.processID != null) {
      this.loadProcess(this.$route.params.processID);
    } else {
      this.show = true;
    }
  },
  data() {
    return {
      loading: false,
      show: false,
      form: {
        id: null,
        number: null,
        start_time: null,
        end_time: null,
        process_type: null,
        shift: null,
        shift_workers: null,
        shift_supervisor: null,
        note: null,
        material_waybill: null,
        plant: {
          id: null,
          company: null,
          plant_code: null,
          name: null
        },
        origin: null,
        process_room: null,
        variety: "",
        product: null,
        condition: "",
        company: "",
        client_customer: null
      },
      // Select options
      plants: [],
      shifts: [],
      supervisors: [],
      process_rooms: [],
      companies: [],
      customers: [],
      products: [],
      varieties: [],
      plantsInfo: {
        shifts: [{ value: null, text: "Cargando..." }],
        process_types: [{ value: null, text: "Cargando..." }],
        supervisors: [{ value: null, text: "Cargando..." }],
        plants: [{ value: null, text: "Cargando..." }]
      },
      origins: [],
      conditions: [
        { value: "Orgánico", text: "Orgánico" },
        { value: "Convencional", text: "Convencional" },
        { value: "Org. (System)", text: "Org. (System)" },
        { value: "Conv. (System)", text: "Conv. (System)" }
      ]
    };
  },
  watch: {
    product(newValue, oldValue) {
      if (newValue) {
        this.getProductSet(newValue);
      }
    },
    client_customer(newValue, oldValue) {
      if (newValue) {
        this.getCompanies(newValue);
      }
    },
    company(newValue, oldValue) {
      if (newValue) {
        this.getCompanyFacilities(newValue);
      }
    },
    plant(newValue, oldValue) {
      if (newValue) {
        this.getProcessRooms(newValue.id);
      }
    }
  },
  computed: {
    product() {
      return this.form.product;
    },
    client_customer() {
      return this.form.client_customer;
    },
    company() {
      return this.form.company;
    },
    plant() {
      return this.form.plant;
    }
  },
  validations: {
    form: {
      client_customer: { required },
      variety: { required },
      origin: { required },
      condition: { required },
      company: { required },
      product: { required },
      shift_workers: { required, numeric },
      shift: { required },
      shift_supervisor: { required },
      start_time: { required: requiredIf(() => userHasScope("edit-process-start-time")) },
      process_room: { required },
      plant: { required }
    }
  },
  mounted() {
    console.log("ACAACK!!! 🐔", this.userHasScope("edit-process-start-time"));
  },
  methods: {
    userHasScope: userHasScope,
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      if (this.$route.params.processID != null) {
        this.updateProcess(this.$route.params.processID);
        return;
      }
      this.submitProcess();
    },
    getCustomers() {
      this.$axios
        .get("/production/get_customers/")
        .then((res) => {
          this.customers = res.data.data;
        })
        .catch((error) => console.log(errors));
    },
    getCompanies(a) {
      this.$axios
        .get("/production/get_companies/" + a + "/")
        .then((res) => {
          this.companies = res.data.data;
        })
        .catch((error) => console.log(errors));
    },
    getCompanyFacilities(a) {
      this.$axios
        .get("/production/get_company_facilities/" + a)
        .then((res) => {
          this.origins = res.data.origins;
        })
        .catch((error) => {
          this.disabled_inputs.plants = true;
        });
    },
    getProducts() {
      this.$axios
        .get("/production/get_products/")
        .then((res) => {
          this.products = res.data.data;
        })
        .catch((error) => console.log(errors));
    },
    getProductSet(a) {
      this.$axios
        .get("/production/get_product_set/" + a)
        .then((res) => {
          this.varieties = res.data.varieties;
        })
        .catch((error) => (this.selected.product_type = ""));
    },
    getProcessRooms(a) {
      this.$axios
        .get("/production/get_plant_process_rooms/" + a)
        .then((res) => {
          this.process_rooms = res.data.process_rooms;
        })
        .catch((error) => console.log(error));
    },
    getPlantsInfo() {
      this.$axios
        .get("/production/get_client_plants/")
        .then((res) => {
          this.plants = res.data.plants;
          this.shifts = res.data.shifts;
          this.supervisors = res.data.workers;
        })
        .catch((error) => console.log(errors));
    },
    async loadProcess(process_id) {
      const thisV = this;
      thisV.loading = true;
      try {
        const res = await thisV.$axios.get("/api/v1/process/" + process_id + "/");
        thisV.form.id = res.data.id;
        thisV.form.client_customer = res.data.client_customer;
        thisV.form.plant.company = res.data.plant.company.id;
        thisV.form.plant = {
          company: res.data.plant.company.id,
          id: res.data.plant.id,
          name: res.data.plant.name,
          plant_code: res.data.plant.plant_code
        };
        thisV.form.number = res.data.number;
        thisV.form.start_time = res.data.start_time;
        thisV.form.end_time = res.data.end_time;
        thisV.form.process_type = res.data.process_type;
        thisV.form.shift = res.data.shift;
        thisV.form.shift_workers = res.data.shift_workers;
        thisV.form.note = res.data.note;
        thisV.form.material_waybill = res.data.material_waybill;
        thisV.form.origin = res.data.sag_filter.origin_id;
        thisV.form.variety = res.data.sag_filter.variety_id;
        thisV.form.product = res.data.sag_filter.product_id;
        thisV.form.condition = res.data.sag_filter.condition;
        thisV.form.company = res.data.sag_filter.company_id;
        thisV.form.process_room = res.data.process_room;
        thisV.form.shift_supervisor = res.data.shift_supervisor;
        thisV.loading = false;
        thisV.$nextTick(() => {
          thisV.show = true;
        });
      } catch (error) {
        console.log(error);
        thisV.show = true;
        thisV.loading = false;
      }
    },
    // Create and Update Process
    async submitProcess() {
      const thisV = this;
      thisV.loading = true;
      const formData = {
        start_time: thisV.form.start_time,
        end_time: thisV.form.end_time,
        process_type: thisV.$route.params.typeProcess,
        shift: thisV.form.shift,
        shift_workers: thisV.form.shift_workers,
        shift_supervisor: thisV.form.shift_supervisor,
        note: thisV.form.note,
        material_waybill: thisV.form.material_waybill,
        process_room: thisV.form.process_room,
        client_customer: thisV.form.client_customer,
        client: thisV.$store.getters.user.ID_CLIENTE,
        sag_filter: {
          product_id: thisV.form.product,
          company_id: thisV.form.company,
          variety_id: thisV.form.variety,
          condition: thisV.form.condition,
          origin_id: thisV.form.origin,
          variety_name: _.find(thisV.varieties, { value: thisV.form.variety })["text"],
          origin_name: _.find(thisV.origins, { value: thisV.form.origin })["text"]
        }
      };
      try {
        const res = await thisV.$axios.post("/api/v1/process/", formData);
        thisV.$swal.fire(`Proceso #${res.data.number} creado con éxito`, "", "success");
        thisV.loading = false;
        thisV.$router.push({ name: "process-listado" });
      } catch (e) {
        thisV.$toast.error("Problemas al crear proceso", "");
        thisV.loading = false;
        console.log(error.response);
      }
    },
    async updateProcess(a) {
      const thisV = this;
      thisV.loading = true;
      const formData = {
        id: parseInt(thisV.$route.params.processID),
        start_time: thisV.form.start_time,
        end_time: thisV.form.end_time,
        process_type: thisV.$route.params.typeProcess,
        shift: thisV.form.shift,
        shift_workers: thisV.form.shift_workers,
        shift_supervisor: thisV.form.shift_supervisor,
        note: thisV.form.note,
        material_waybill: thisV.form.material_waybill,
        process_room: thisV.form.process_room,
        client_customer: thisV.form.client_customer,
        client: thisV.$store.getters.user.ID_CLIENTE,
        sag_filter: {
          product_id: thisV.form.product,
          company_id: thisV.form.company,
          variety_id: thisV.form.variety,
          condition: thisV.form.condition,
          origin_id: thisV.form.origin,
          variety_name: _.find(thisV.varieties, { value: thisV.form.variety })["text"],
          origin_name: _.find(thisV.origins, { value: thisV.form.origin })["text"]
        }
      };
      try {
        const res = await thisV.$axios.put("/api/v1/process/" + a + "/", formData);
        thisV.$swal.fire(`Proceso #${res.data.number} editado con éxito`, "", "success");
        thisV.$router.push({ name: "process-listado" });
        thisV.loading = false;
      } catch (e) {
        thisV.$toast.error("Problemas al crear proceso", "");
        thisV.loading = false;
        console.log(e.response);
      }
    }
  }
};
</script>

<style>
.wizard-header {
  padding: 0px !important;
}
</style>
